import { render, staticRenderFns } from "./add-coupon.vue?vue&type=template&id=4c552e22&scoped=true&"
import script from "./add-coupon.vue?vue&type=script&lang=js&"
export * from "./add-coupon.vue?vue&type=script&lang=js&"
import style0 from "./add-coupon.vue?vue&type=style&index=0&id=4c552e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c552e22",
  null
  
)

export default component.exports